const sanzione2 = [
  {
    matricolaControllore: "0790AD",
    importo: 5800,
    dataDiEmissione: 1649685005000,
    annotazioneControllore: "il signore si e comportato molto male e la tua sanzione sara sanzionata",
    isverbaleFattoABordo: 0,
    id: 1,
    numeroSanzione: "2022/00065",
    cliente: { client: 2, nome: "FNM" },
    anagraficaTipologiaSanzione: {
      nomeViolazione: "Violazione numero 1"
    },
  },
   {
    matricolaControllore: "0790AD",
    importo: 5800,
    dataDiEmissione: 1649685005000,
    annotazioneControllore: "",
    isverbaleFattoABordo: 0,
    id: 1,
    numeroSanzione: "2022/00075",
    cliente: { client: 2, nome: "FNM" },
    anagraficaTipologiaSanzione: {
      nomeViolazione: "Violazione numero 2"
    },
  },
  {
    matricolaControllore: "0790AD",
    importo: 5800,
    dataDiEmissione: 1649685005000,
    annotazioneControllore: "",
    isverbaleFattoABordo: 0,
    id: 1,
    numeroSanzione: "2022/00078",
    cliente: { client: 2, nome: "FNM" },
    anagraficaTipologiaSanzione: {
      nomeViolazione: "Violazione numero 3"
    },
  },
  
];

export default sanzione2;
